<template>
    <div class="modal">
        <div class="add-new-modal" @click="isShowAddBtn = false" v-show="isShowAddBtn">
            <div class="add-new-modal-bg"></div>
            <div class="handle-btn-list">
                <transition name="fade">
                    <ul class="hidden-nav-list" v-show="isShowAddBtn">
                        <li class="add-new-item" v-for="(item,index) of addBtnList" :key="index">
                            <a href="javascript:;" class="item-main" @click.stop="handleClickPublishBtn(item)">
                                <span class="item-title">
                                    {{ item.name }}
                                </span>
                                <span class="item-icon" :class="'add-btn-'+(index + 1)"></span>
                            </a>
                        </li>
                    </ul>
                </transition>
            </div>
        </div>
        <!--<a href="javascript:;" class="add-new-btn" :class="{show:isShowAddBtn}" @click="handleCreateDynamic">-->
        <!--   <span class="iconfont">-->
        <!--       &#xe8a7;-->
        <!--    </span>-->
        <!--</a>-->
    </div>
</template>
<script>
    export default {
        name: 'addNewBtn',
        data() {
            return {
                addBtnList: [{
                    link: "/mall/demand/publish",
                    name: "发布需求",
                    // svgIcon: "needs"
                }, {
                    link: "/mall/achievement/publish",
                    name: "提交成果",
                    // svgIcon: "fruit"
                }, {
                    link: "/meeting/create",
                    name: "创建会议",
                    // svgIcon: "meet"
                }, {
                    link: "/sns/forward",
                    name: "发布动态",
                    // svgIcon: "dynamic"
                }],
                isShowAddBtn: false

            }
        },
        methods: {
            handleCreateDynamic() {
                this.isShowAddBtn = !this.isShowAddBtn;
            },
            handleClickPublishBtn(item){
                let { token } = this.$store.getters;
                let { path, query } = this.$route;

                if(!window.sma.isApp.innovationChina && !token){
                    this.$toast("请先登录");
                    // 登陆时设置为8
                    this.$store.dispatch("app/changeNavIndex", 8);
                    setTimeout(() => {
                        this.$router.push("/login?callback=" + path+"&query="+ JSON.stringify(query));
                    }, 1500);
                    return false;
                }
                // 如果已经登陆就跳转到对应的新增页
                this.$router.push(item.link);
            }
        }
    }

</script>
<style lang="scss" scoped>
$IconbaseURI:"~@/assets/images/icons/";

.fade-enter,
.fade-leave-to {
    transform: scaleY(0);
}

.fade-enter-active,
.fade-leave-active {
    transition: all .3s ease;
}

.add-new-modal {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 99998;

    &-bg {

        background-color: rgba(255, 255, 255, 0.9);
        position: absolute;
        filter: blur(10px);
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 0;

    }

    .handle-btn-list {
        position: fixed;
        bottom: 250px;
        right: 20px;
        z-index: 1;


        .hidden-nav-list {
            //
            transform-origin: bottom center;

            // display: none;
            // transform: scaleY(0);

            .add-new-item {
                margin-bottom: 10px;

                .item-main {
                    display: flex;
                    align-items: center;
                }

                .item-title {
                    font-size: 32px;
                    color: #333;
                    // margin-right: 10px;
                }

                .item-icon {
                    width: 80px;
                    height: 80px;
                    background: no-repeat center/cover;

                    // display: inline-block;
                    @for $i from 1 through 4 {
                        &.add-btn-#{$i} {
                            background-image:url($IconbaseURI + 'icon-add-#{$i}.png');
                        }
                    }
                }
            }
        }
    }
}

.add-new-btn {
    position: fixed;
    bottom: 170px;
    right: 20px;
    z-index: 99999;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
    display: block;
    border-radius: 50%;
    float: right;
    background: linear-gradient(315deg, #0071FF 0%, #33A2FF 100%);
    box-shadow: 0px 2px 10px 0px rgba(22, 135, 255, 0.5);
    transition: all .3s;
    text-align:center;

    &.show {
        transform: rotate(135deg);
    }

    span {
        color: #fff;
        font-size: 36px;
        // display: block;

        font-weight: 800;
    }
}

</style>
